module.exports = __webpack_public_path__ + "img/WP2023-Dubai3.b690def1.jpg";